/***
 * Created on 2024/4/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import QnapAuthPairDevicePanelRow from "./qnap_auth_pair_device_panel_row";
import {getLocalUser} from "../../../../../../service/user";
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../../../hook/pre_check_password";

function QnapAuthPairDevicePanel({state, dispatch}) {
    const { t } = useTranslation();
    const currentUser = getLocalUser();
    const {checkPassword} = usePreCheckPassword();
    const [showDevices, setShowDevices] = React.useState(false);

    const onAddDevice = async () => {
        await checkPassword({
            onSuccess: () => dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: true, opts: {newDevice: true}}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleShowInitQnapAuthAppSetup', opts: {newDevice: true}})
        });
    }

    return (
        <section className="two-step--paired-devices">
            <div className="comp-content-wrapper">
                <div className="comp-accordion">
                    <div className={`accordion__trigger-bar cursor-pointer ${showDevices ? 'active' : ''}`} onClick={()=>setShowDevices(prev => !prev)}>
                        <div className="accordion__trigger-bar__text">
                            {t('@View and remove current pairings of QNAP Authenticator on different mobile devices. You can have up to 5 paired mobile devices.@')}
                        </div>
                        <div className="accordion__trigger-bar__arrow"></div>
                    </div>
                     <div className="accordion__wrapper">
                         <div className="accordion__inner">
                             <div className="accordion__inner__tool-bar">
                                 <div className="amount-info">
                                     <span className="amount-info__label display-inline-block !mr-8">{t('@Paired devices:@')}</span>
                                     <span className="amount-info__amount display-inline-block">
                                         <span className="display-inline-block text-16 font-medium color-primary">{Object.entries(currentUser?.secure?.qnap_auth?.devices || []).length || 0}</span>
                                         <span className="display-inline-block text-16 ml-4 mr-4">/</span>
                                         <span className="display-inline-block text-16">5</span>
                                     </span>
                                 </div>
                                 <div className="accordion__inner__tool-bar__col-divide"></div>
                                 <button className="q-btn q-btn--default btn-small btn-rounded-full min-w-0 !pl-18 !pr-18"
                                         onClick={onAddDevice}>
                                     {t('@Add Device@')}
                                 </button>
                             </div>
                             {currentUser?.secure?.qnap_auth?.devices &&
                                 <div className="comp-flex-table">
                                     <div className="flex-table-wrapper">
                                         <div className="flex-table-header">
                                             <div className="flex-table__cell flex-table-header__cell w-21">{t('@Device Name@')}</div>
                                             <div className="flex-table__cell flex-table-header__cell w-20">{t('@Modal/OS Version@')}</div>
                                             <div className="flex-table__cell flex-table-header__cell w-22">{t('@Date Added@')}</div>
                                             <div className="flex-table__cell flex-table-header__cell w-22">{t('@Last Login@')}</div>
                                             <div className="flex-table__cell flex-table-header__cell w-15">{t('@Action@')}</div>
                                         </div>
                                         <div className="flex-table-body">
                                             {(Object.values(currentUser?.secure?.qnap_auth?.devices || {})).map((device) =>  <QnapAuthPairDevicePanelRow device={device} key={device.id} />)}
                                         </div>
                                     </div>
                                 </div>
                             }
                         </div>
                     </div>
                </div>
            </div>
        </section>
    );
}

export default QnapAuthPairDevicePanel;